module.exports = __webpack_public_path__ + "img/ai-avatar.9617b788.png";